<template>
    <div>
        <!-- 공통 시작 -->
        <div class="row form-group">
            <div class="col-lg-6">
                <label v-if="parentFacilityIdx">
                    <trans>수집항목 선택</trans>
                </label>
                <label v-else>
                    <trans>드라이버 선택</trans>
                </label>
                <!-- 신규장비만 드라이버 선택 가능 : 장비 수정, 하위장비 추가, 수정시 모두 선택불가능 -->
                <select
                    class="form-control"
                    v-model="newFacility.driverType"
                    :disabled="isUpdate || !isEmpty(parentFacilityIdx)"
                >
                    <option v-for="(driverType, i) in driverTypes" :key="i" :value="driverType">
                        {{ driverType == "" ? $t("드라이버 선택") : driverType }}
                    </option>
                </select>
            </div>
            <div class="col-lg-3">
                <label>
                    <trans>버전</trans>
                </label>
                <select
                    class="form-control"
                    v-model="newFacility.version"
                    :disabled="isUpdate || !isEmpty(parentFacilityIdx)"
                >
                    <option v-for="(driver, i) in getVersion" :key="i" :value="driver.version">
                        {{ driver.version }}
                    </option>
                </select>
            </div>
            <div class="col-lg-3">
                <label>관리 옵션</label>
                <div class="btn-group d-flex justify-content-between align-items-center">
                    <!-- <input type="checkbox" :id="'facilityDetail_' + newFacility.facilityIdx"
						v-model="newFacility.isUse" />
					<label :for="'facilityDetail_' + newFacility.facilityIdx">
						<trans>사용여부</trans>
					</label> -->

                    <button
                        type="button"
                        class="btn"
                        :class="newFacility.isUse ? 'btn-warning' : 'btn-light'"
                        @click="newFacility.isUse = !newFacility.isUse"
                    >
                        {{ newFacility.isUse ? "사용중" : "사용중단" }}
                    </button>
                </div>
            </div>
        </div>
        <!-- 공통 끝 -->

        <!-- 계측장치 시작 -->
        <div class="row form-group" v-if="!parentFacilityIdx">
            <div class="col-lg-4" v-if="!parentFacilityIdx">
                <label>
                    <trans>계측기명</trans>
                </label>
                <valid-input
                    :vid="'계측기명'"
                    :inputType="'text'"
                    :inputValue.sync="newFacility.facilityName"
                    :rules="rules.COLLECT_DATA_MEASUING_ID_RULE"
                    :errorMessage="validMessage.COMMON_ALPHA_NUM_LENGTH_VALID_MESSAGE(1, 30)"
                    :placeholder="$t('계측기명 입력')"
                    :isMessage="true"
                    @inputMethod="newFacility.facilityName = newFacility.facilityName.toUpperCase()"
                ></valid-input>
            </div>
            <div class="col-lg-5" v-if="!parentFacilityIdx">
                <label>
                    <trans>계측기 표시명</trans>
                </label>
                <valid-input
                    :vid="'표시 계측기명'"
                    :inputType="'text'"
                    :inputValue.sync="newFacility.facilityAlias"
                    :rules="rules.COLLECT_DATA_MEASUING_NAME_RULE"
                    :errorMessage="validMessage.COMMON_BOTH_LENGTH_VALID_MESSAGE(1, 30)"
                    :placeholder="$t('화면 표시명 입력')"
                    :isMessage="true"
                    @inputMethod="inputFacilityAlias"
                ></valid-input>
            </div>
            <div class="col-lg-3">
                <label>
                    <trans>장치 고유번호</trans>
                </label>
                <valid-input
                    :vid="'장치 고유번호'"
                    :inputType="'number'"
                    :inputValue.sync="newFacility.deviceId"
                    :rules="rules.COLLECT_DATA_EQUIP_UNIQUE_NUM_RULE"
                    :placeholder="$t('장치 고유번호')"
                    :NonStatus="true"
                    :disabled="!isEmpty(parentFacilityIdx)"
                ></valid-input>
            </div>
        </div>

        <div class="row form-group" v-if="!parentFacilityIdx">
            <div class="col-lg-4">
                <label>
                    <trans>{{ "활용 목적" }}</trans>
                </label>

                <select class="form-control" v-model="newFacility.purpsUseCode">
                    <option :value="null">{{ "선택" }}</option>
                    <option
                        v-for="(code, index) in commonCodes.purpsUseCode"
                        :key="`${code}-${index}`"
                        :value="code.value"
                    >
                        {{ code.text }}
                    </option>
                </select>
            </div>
            <div class="col-lg-4">
                <label>
                    <trans>계측기 유형</trans>
                </label>
                <select class="form-control" v-model="newFacility.meterTypeCode">
                    <option :value="null">{{ $t("선택") }}</option>
                    <!-- <option v-for="(meterType, i) in getMeterTypeList" :key="i" :value="meterType.smallCode">{{
						meterType.smallCodeName }}</option> -->
                    <option v-for="code in commonCodes.meterTypeCode" :key="code.value" :value="code.value">
                        {{ code.text }}
                    </option>
                </select>
            </div>
            <div class="col-lg-4">
                <label>
                    <trans>측정방법</trans>
                </label>
                <select class="form-control" v-model="newFacility.measTypeCode">
                    <option :value="null">{{ $t("선택") }}</option>
                    <!-- <option v-for="(meterType, i) in getMeterTypeList" :key="i" :value="meterType.smallCode">{{
						meterType.smallCodeName }}</option> -->
                    <option v-for="code in commonCodes.measTypeCode" :key="code.value" :value="code.value">
                        {{ code.text }}
                    </option>
                </select>
            </div>
        </div>

        <div class="row form-group" v-if="!parentFacilityIdx">
            <div class="col-lg-4">
                <label>
                    <trans>적용구역</trans>
                </label>
                <select class="form-control" v-model="newFacility.applyZoneIdx">
                    <option :value="null">{{ $t("선택") }}</option>
                    <option v-for="code in $store.state.zoneInfo" :key="code.value" :value="code.value">
                        {{ code.text }}
                    </option>
                </select>
            </div>
            <div class="col-lg-4">
                <label>
                    <trans>설치일자</trans>
                </label>
                <input
                    type="text"
                    class="form-control"
                    :class="classes"
                    :placeholder="$t('YYYY-MM-DD')"
                    v-model="newFacility.instDate"
                />
            </div>
            <div class="col-lg-4">
                <label>
                    <trans>검교정 주기</trans>
                </label>
                <select class="form-control" v-model="newFacility.clbrPeriodCode">
                    <option :value="null">{{ $t("선택") }}</option>
                    <option v-for="code in commonCodes.clbrPeriodCode" :key="code.value" :value="code.value">
                        {{ code.text }}
                    </option>
                </select>
            </div>
        </div>
        <!-- 계측장치 끝 -->

        <!-- 서브모듈 시작 -->
        <div class="row form-group" v-if="parentFacilityIdx">
            <div class="col-lg-12">
                <div v-if="facilityIdx" class="alert alert-secondary fade show">
                    '{{ parentFacility.facilityName }}' {{ $t("의 서브모듈 입니다.") }}
                </div>
                <div v-else class="alert alert-secondary fade show">
                    '{{ parentFacility.facilityName }}' {{ $t("의 서브모듈로 등록됩니다.") }}
                </div>
            </div>
        </div>

        <div class="row form-group" v-if="parentFacilityIdx">
            <div class="col-lg-3">
                <label> <trans>모듈번호</trans> (CT) </label>
                <valid-input
                    :vid="'모듈번호'"
                    :inputType="'number'"
                    :inputValue.sync="newFacility.ct"
                    :rules="rules.COLLECT_DATA_MODULE_NUM_RULE"
                    :errorMessage="validMessage.COMMON_NUMBER_LENGTH_VALID_MESSAGE(1, 999)"
                    :placeholder="$t('모듈번호 지정')"
                    :isMessage="true"
                ></valid-input>
            </div>

            <div class="col-lg-4">
                <label>
                    <trans>모듈명</trans>
                </label>
                <valid-input
                    :vid="'서브 모듈명'"
                    :inputType="'text'"
                    :inputValue.sync="newFacility.facilityName"
                    :rules="rules.COLLECT_DATA_MODULE_NAME_RULE"
                    :errorMessage="validMessage.COMMON_BOTH_LENGTH_VALID_MESSAGE(1, 30)"
                    :placeholder="$t('서브 모듈명 입력')"
                    :isMessage="true"
                ></valid-input>
            </div>
            <div class="col-lg-5">
                <label>
                    <trans>모듈 표시명</trans>
                </label>
                <valid-input
                    :vid="'표시 서브 모듈명'"
                    :inputType="'text'"
                    :inputValue.sync="newFacility.facilityAlias"
                    :rules="rules.COLLECT_DATA_MODULE_NAME_RULE"
                    :errorMessage="validMessage.COMMON_BOTH_LENGTH_VALID_MESSAGE(1, 30)"
                    :placeholder="$t('서브 모듈 표시명 입력')"
                    :isMessage="true"
                    @inputMethod="inputFacilityAlias"
                ></valid-input>
            </div>
        </div>

        <div class="row form-group" v-if="parentFacilityIdx && parentFacility.driverType != 'KIEMECS_CTRL'">
            <div class="col-lg-6">
                <label>{{ $t("외부 데이터 매핑키") }}</label>
                <valid-input
                    :vid="'외부 데이터 매핑키'"
                    :inputType="'text'"
                    :inputValue.sync="newFacility.mappingKey"
                    :rules="rules.COLLECT_DATA_MAPPING_KEY_RULE"
                    :placeholder="$t('데이터 매핑키 입력')"
                    :NonStatus="true"
                ></valid-input>
            </div>
            <div class="col-lg-3" v-if="parentFacility.measTypeCode == 'Pulse'">
                <label>펄스당 용량</label>
                <select
                    class="form-control"
                    v-model="newFacility.facilityOption.pulseUnit"
                    :ref="'pulseUnit'"
                    @input="setPulseUnit"
                >
                    <option :value="null">{{ $t("선택") }}</option>
                    <option value="0.001">0.001</option>
                    <option value="0.01">0.01</option>
                    <option value="0.1">0.1</option>
                    <option value="1">1</option>
                    <option value="10">10</option>
                    <option value="100">100</option>
                    <option value="1000">1000</option>
                </select>
            </div>
            <div class="col-lg-3">
                <label>
                    <trans>적용 구역</trans>
                </label>
                <select class="form-control" v-model="newFacility.applyZoneIdx">
                    <option :value="null">{{ $t("선택") }}</option>
                    <option v-for="code in $store.state.zoneInfo" :key="code.value" :value="code.value">
                        {{ code.text }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row form-group" v-if="parentFacilityIdx && parentFacility.driverType == 'KIEMECS_CTRL'">
            <div class="col-lg-4">
                <label>{{ $t("GS SYSTEM ID") }}</label>
                <valid-input
                    :vid="'GS SYSTEM ID'"
                    :inputType="'text'"
                    :inputValue.sync="newFacility.facilityOption.gsSystemId"
                    :rules="rules.COLLECT_DATA_MAPPING_KEY_RULE"
                    :placeholder="$t('데이터 매핑키 입력')"
                    :NonStatus="true"
                ></valid-input>
            </div>
            <div class="col-lg-4">
                <label>{{ $t("SC SYSTEM ID") }}</label>
                <valid-input
                    :vid="'SC SYSTEM ID'"
                    :inputType="'text'"
                    :inputValue.sync="newFacility.facilityOption.scSystemId"
                    :rules="rules.COLLECT_DATA_MAPPING_KEY_RULE"
                    :placeholder="$t('데이터 매핑키 입력')"
                    :NonStatus="true"
                ></valid-input>
            </div>
            <div class="col-lg-3">
                <label>
                    <trans>적용 구역</trans>
                </label>
                <select class="form-control" v-model="newFacility.applyZoneIdx">
                    <option :value="null">{{ $t("선택") }}</option>
                    <option v-for="code in $store.state.zoneInfo" :key="code.value" :value="code.value">
                        {{ code.text }}
                    </option>
                </select>
            </div>
        </div>

        <div class="row form-group" v-if="parentFacilityIdx">
            <div class="col-lg-4">
                <label>
                    <trans>사용 에너지원</trans>
                </label>
                <select class="form-control" v-model="newFacility.energySourceCode">
                    <option :value="null">{{ $t("선택") }}</option>
                    <option v-for="code in commonCodes.energySourceCode" :key="code.value" :value="code.value">
                        {{ code.text }}
                    </option>
                </select>
            </div>
            <div class="col-lg-4">
                <label>{{ $t("사용용도") }}</label>
                <select class="form-control" v-model="newFacility.usageCode">
                    <option :value="null">{{ $t("선택") }}</option>
                    <option v-for="code in commonCodes.phscPointUsage" :key="code.value" :value="code.value">
                        {{ code.text }}
                    </option>
                </select>
            </div>
            <div class="col-lg-4">
                <label>{{ $t("에너지 공급원 구분") }}</label>
                <select
                    class="form-control"
                    v-model="newFacility.energySplyTypeCode"
                    :disabled="!(newFacility.usageCode === 'Panel')"
                >
                    <option :value="null">{{ $t("선택") }}</option>
                    <option v-for="code in commonCodes.energySplyTypeCode" :key="code.value" :value="code.value">
                        {{ code.text }}
                    </option>
                </select>
            </div>
        </div>

        <!-- 공통 푸터 (remark) -->

        <div class="row form-group">
            <div class="col-lg-12">
                <label>
                    <trans>비고</trans>
                </label>
                <textarea
                    class="form-control"
                    :placeholder="$t('비고')"
                    v-model="newFacility.remark"
                    rows="3"
                ></textarea>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    props: [
        "newFacility",
        "parentFacility",
        "facilityIdx",
        "parentFacilityIdx",
        "drivers",
        "driverTypes",
        "getVersion",
        "rules",
        "validMessage",
        "classes",
        "isUpdate",
        "meterTypeCode",
        "measTypeCode",
        "newCT",
        "aliasSynced",
        "mode",
    ],
    watch: {
        // 활용 목적 코드에 대한 디폴트 값 설정
        "newFacility.purpsUseCode": {
            handler: function(newVal) {
                if ((newVal == null || newVal == "" || newVal == undefined) && this.mode == "panel") {
                    this.newFacility.purpsUseCode = "Bep";
                } else {
                    this.newFacility.purpsUseCode = newVal;
                }
            },
            immediate: true,
        },
    },
    computed: {
        ...mapState(["commonCodes"]),
    },
    methods: {
        inputFacilityAlias() {
            this.$emit("input-facility-alias");
        },
        setPulseUnit() {
            this.$emit("set-pulse-unit");
        },
    },
};
</script>
